Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconCameraData: "data:image/svg+xml,%3csvg width='24' height='19' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M14.394 0a2 2 0 011.11.336L18 2h4a2 2 0 012 2v13a2 2 0 01-2 2H2a2 2 0 01-2-2V4a2 2 0 012-2h4L8.496.336A2 2 0 019.606 0h4.788zm0 2H9.606L7.109 3.664a2 2 0 01-.94.329L6 4H2v13h20V4h-4a2 2 0 01-.965-.248l-.144-.088L14.394 2zM12 5a5 5 0 110 10 5 5 0 010-10zm0 2a3 3 0 100 6 3 3 0 000-6zM4 6a1 1 0 110 2 1 1 0 010-2z' fill='currentColor' fill-rule='nonzero'/%3e%3c/svg%3e",
  iconCameraWidth: 24,
  iconCameraHeight: 19
};